import { PropertyDto } from '@/features/RentersInsurance/types/property.type';

export type MappedPropertyList = Array<Omit<PropertyDto, 'propertyId'> & { id: string }>;

export function mapPropertyListResultToPropertyList(
  propertyList: PropertyDto[],
): MappedPropertyList {
  return propertyList.map((property) => ({
    id: property.propertyId,
    name: property.name,
    marketingName: property.marketingName,
    revision: property.revision,
    type: property.type,
    city: property.city,
    state: property.state,
    zipCode: property.zipCode,
    hubspotPropertyId: property.hubspotPropertyId,
    isActive: property.isActive,
    createdDateUtc: property.createdDateUtc,
    updatedDateUtc: property.updatedDateUtc,
  }));
}
